import GoogleLocationsFilters from './GoogleLocationsFilters';
import GoogleLocationsGroups from './GoogleLocationsGroups';

export { useGoogleLocationsFilter } from './useGoogleLocationsFilter';
export { GoogleLocationsFilters, GoogleLocationsGroups };

const GoogleLocationsList = ({ filter, renderLocation }) => (
    <>
        <GoogleLocationsFilters filter={filter} />
        <GoogleLocationsGroups filter={filter} renderLocation={renderLocation} />
    </>
);

export default GoogleLocationsList;
